import { useEffect, useRef } from 'react'
import WaveShape from './WaveShape.js'

const COLORS = ['#e67e22', '#d35400', '#e74c3c', '#c0392b', '#f39c12', '#d35400']

function calculateDimensions() {
  const width = document.body.clientWidth
  let height = 0.2 * width
  if (width < 1160) height = 0.5 * width
  if (width < 520) height = 0.8 * width
  if (width < 316) height = width
  return { width, height }
}

function calculateSpacing(width) {
  let spacing = width / 20
  if (width < 1160) spacing = width / 12
  if (width < 520) spacing = width / 8
  if (width < 316) spacing = width / 6
  return spacing
}

function generateShapes(count, midY, spacing, width) {
  const shapes = []
  const offsets = [
    [20, 40, -50],
    [80, 60, -50],
    [110, 80, -50],
    [150, 100, -50],
    [200, 130, -50],
    [250, 170, -50],
  ]
  for (let layer = 0; layer < count; layer++) {
    const [base, range, shift] = offsets[layer]
    const points = []
    let offset = 0
    for (let x = 0; x <= width + width / 4; x += spacing) {
      offset = base + range * Math.random() + shift
      offset -= x / 20
      points.push({
        x,
        y: midY + offset + 10 + 20 * Math.random(),
        oldY: midY + offset,
        angle: 360 * Math.random(),
        speed: 0.025,
      })
    }
    shapes.push(new WaveShape(points, COLORS[layer]))
  }
  return shapes
}

export default function Overlay({ children }) {
  const wrapRef = useRef(null)
  const canvasRef = useRef(null)
  const shapesRef = useRef([])
  const sizeRef = useRef({ width: 0, height: 0 })
  const rafRef = useRef(0)

  useEffect(() => {
    const wrap = wrapRef.current
    if (!wrap) return undefined

    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')

    const applySize = () => {
      const { width, height } = calculateDimensions()
      sizeRef.current = { width, height }
      canvas.width = width
      canvas.height = height
      shapesRef.current = generateShapes(6, height / 2, calculateSpacing(width), width)
    }

    const draw = () => {
      const { width, height } = sizeRef.current
      ctx.clearRect(0, 0, width, height)
      shapesRef.current.forEach((s) => s.render(ctx, width, height))
      rafRef.current = requestAnimationFrame(draw)
    }

    applySize()
    draw()
    window.addEventListener('resize', applySize)

    return () => {
      cancelAnimationFrame(rafRef.current)
      window.removeEventListener('resize', applySize)
    }
  }, [])

  return (
    // position:relative so .footer-mandril (absolute) anchors here
    <div className="overlay" ref={wrapRef}>
      {/* canvas is a normal block element — it sets the container height */}
      <canvas ref={canvasRef} style={{ display: 'block', width: '100%' }} />
      {/* children sit on top via absolute positioning (handled by .footer-mandril CSS) */}
      {children}
    </div>
  )
}
